export default "/images/5e72796bc08701b1e561ae9cdc27e90a.avif";